/*
 *------------------------------------------------------------------
 * Global.js
 *
 * Initializes the global data structures used.
 *
 * June 2020, Rohith Raj S
 *
 * Copyright (c) 2020-2023 by Cisco Systems, Inc.
 * All rights reserved.
 *------------------------------------------------------------------
 */

/*
 * Initilaizes the global data structures.
 * 1. headersSelected = array
 * 2. srv6Length = dictionary
 */
var MY_GLOBAL = { headersSelected: [], srv6Length: {} };

export default MY_GLOBAL;
